import Vue from 'vue'

Vue.filter('currency', function (n) {
  let val = null
  if (n.toString().includes('.')) {
    val = (n / 1).toFixed(2).replace(',', '.')
  } else {
    val = (n / 1).toString().replace(',', '.')
  }
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})



// WEBPACK FOOTER //
// ./src/Filters/CurrencyFormatFilter.js